/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  CreateCertifiedPlant,
  CreateCertifiedPlantType,
} from '..';
import {
  serializeCreateCertifiedPlant,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface CreateCertifiedPlantInput {
  plant: CreateCertifiedPlant;
}
const build = (_query: DocumentNode, input: CreateCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plant !== undefined ? `$plant: CreateCertifiedPlant = ${serializeCreateCertifiedPlant(input.plant)}` : '' ) + `){
    createCertifiedPlant(
      ${ input.plant !== undefined ? 'plant: $plant,' : '' }
    ){
      ...createcertifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class CreateCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment createcertifiedplanttype on CreateCertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: CreateCertifiedPlantInput): Promise<apollo.FetchResult< { createCertifiedPlant: Partial<CreateCertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ createCertifiedPlant: Partial<CreateCertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
